import { useEffect, useState } from 'react'
import io from 'socket.io-client'
import store from 'store2'
import { JWT_TOKEN_NAME } from '../constants/auth-key'

export default function useSocket(query?: Record<string, any>) {
  const [activeSocket, setActiveSocket] = useState<any>(null)

  const jwtToken = store.get(JWT_TOKEN_NAME)

  function socketCleanup() {
    if (!activeSocket) {
      return
    }
    activeSocket.offAny()
    setActiveSocket(null)
  }

  useEffect(() => {
    if (activeSocket) {
      return
    }
    const socket = io(process.env.REACT_APP_WS_SERVICE, {
      transports: ['websocket'],
      path: '/ws/',
      reconnection: true,
      reconnectionAttempts: 10,
      query: { token: jwtToken ?? '' },
    })
    setActiveSocket(socket)
    return socketCleanup
  }, [])
  return activeSocket
}
